export const SOFTLINE_API_BONUSABFRAGE_PERIODEN = 'dfhdois-service/dfh-bonus/periods';
export const SOFTLINE_API_BONUSABFRAGE_STAFFELN = 'dfhdois-service/dfh-bonus/tiered-bonus';
export const SOFTLINE_API_BONUSABFRAGE_UMSATZ = 'dfhdois-service/dfh-bonus/revenue';
